export default "__VITE_ASSET__Dt7v0eNy__"